import { render, staticRenderFns } from "./BundlePackageCard.vue?vue&type=template&id=511655aa"
import script from "./BundlePackageCard.vue?vue&type=script&lang=js"
export * from "./BundlePackageCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports